'use client'

import { ErrorBoundary } from '@/components/error-page/error-boundary'
import { useSupport } from '@/components/Providers/SupportProvider'

import type React from 'react'

type Props = {
  children: React.ReactNode
}

export function ErrorBoundaryWrapper({ children }: Props) {
  const { show } = useSupport()

  return <ErrorBoundary onChatToUsClick={show}>{children}</ErrorBoundary>
}
